import React from "react";
import CloseImg from "../../../assets/img/cancel.svg";
import PortfolioData from "../portfolioData";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Modal = ({ modalId, setGetModal }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
  };

  const item = PortfolioData.find((item) => item.id === modalId);
  if (!item) return null;

  // Prefer item.images[] (new), fallback to item.image (old)
  const images =
    Array.isArray(item.images) && item.images.length
      ? item.images
      : item.image
      ? [item.image]
      : [];

  return (
    <div className="modal_portfolio">
      <div className="modal__outside" onClick={() => setGetModal(false)} />

      <div className="modal__content">
        <div key={item.id} data-aos="fade">
          <h2 className="heading mb-2">{item.type}</h2>

          {/* Existing details block (kept) */}
          <div className="modal__details">
            {item.modalDetails?.map((details, i) => (
              <div key={i} className="row open-sans-font">
                {details.project && (
                  <div className="col-12 col-sm-6 mb-2">
                    <i className="fa fa-file-text-o pr-2" />
                    Project:{" "}
                    <span className="ft-wt-600 uppercase">{details.project}</span>
                  </div>
                )}
                {details.client && (
                  <div className="col-12 col-sm-6 mb-2">
                    <i className="fa fa-user-o pr-2" />
                    Client:{" "}
                    <span className="ft-wt-600 uppercase">{details.client}</span>
                  </div>
                )}
                {details.language && (
                  <div className="col-12 col-sm-6 mb-2">
                    <i className="fa fa-code pr-2" />
                    Language:{" "}
                    <span className="ft-wt-600 uppercase">
                      {details.language}
                    </span>
                  </div>
                )}
                {details.program && (
                  <div className="col-12 col-sm-6 mb-2">
                    <i className="fa fa-desktop pr-2" />
                    Program:{" "}
                    <span className="ft-wt-600 uppercase">
                      {details.program}
                    </span>
                  </div>
                )}
                {details.link && (
                  <div className="col-12 col-sm-6 mb-2">
                    <i className="fa fa-external-link pr-2" />
                    Preview:{" "}
                    <a
                      className="preview-link"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      href={details.link}
                    >
                      {details.preview || details.link}
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* NEW: Summary */}
          {item.summary ? (
            <div className="open-sans-font mt-3">
              <p className="mb-0" style={{ opacity: 0.9 }}>
                {item.summary}
              </p>
            </div>
          ) : null}

          {/* NEW: Role + Stack */}
          {(item.role?.length || item.stack?.length) ? (
            <div className="row open-sans-font mt-3">
              {item.role?.length ? (
                <div className="col-12 col-sm-6 mb-2">
                  <strong>Role:</strong>{" "}
                  {item.role.map((r) => (
                    <span key={r} className="badge badge-light mr-1">
                      {r}
                    </span>
                  ))}
                </div>
              ) : null}

              {item.stack?.length ? (
                <div className="col-12 col-sm-6 mb-2">
                  <strong>Stack:</strong>{" "}
                  {item.stack.map((s) => (
                    <span key={s} className="badge badge-light mr-1">
                      {s}
                    </span>
                  ))}
                </div>
              ) : null}
            </div>
          ) : null}

          {/* NEW: KPIs */}
          {item.kpis?.length ? (
            <div className="open-sans-font mt-3">
              <h4 className="mb-2">Impact</h4>
              <div className="row">
                {item.kpis.map((k) => (
                  <div key={k.label} className="col-12 col-sm-4 mb-2">
                    <div className="kpi-card">
                      <div className="kpi-value">{k.value}</div>
                      <div className="kpi-label">{k.label}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {/* NEW: What I did */}
          {item.bullets?.length ? (
            <div className="open-sans-font mt-3">
              <h4 className="mb-2">What I did</h4>
              <ul className="mb-0">
                {item.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </div>
          ) : null}

          {/* Images */}
          <figure className="modal__img mt-4">
            {images.length ? (
              <Slider {...settings}>
                {images.map((src, idx) => (
                  <div key={`${src}-${idx}`}>
                    <img src={src} alt={`${item.type} screenshot ${idx + 1}`} />
                  </div>
                ))}
              </Slider>
            ) : null}
          </figure>

          <button className="close-modal" onClick={() => setGetModal(false)}>
            <img src={CloseImg} alt="close modal" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
